export default class CardClass {
    constructor() {

    }


    createCard(options) {
        // Create the main card element
        const $card = $('<div>').addClass('card mb-3');

        if(options.id)
            $card.attr('id', options.id);

        // Add image if provided
        if (options.image) {
            const $cardImage = $('<img>')
                .addClass('card-img-top')
                .attr('src', options.image)
                .attr('alt', options.title || 'Card image');
            $card.append($cardImage);
        }
        const $cardHeader = $('<div>')
            .addClass(`card-header ${options.headerClass || 'bg-info-subtle'}`)
            .appendTo($card);

        // Create card body
        const $cardBody = $('<div>')
            .addClass(`card-body ${options.bodyClass || ''}`)
            .appendTo($card);


        // Add title
        if (options.title) {
            $('<h5>')
                .addClass('card-title')
                .html(options.title)
                .appendTo($cardHeader);
        }// Add buttons
        if (options.topButtons) {
            $cardHeader.prepend(options.topButtons);
        }

        // Add text
        if (options.text) {
            $('<p>')
                .addClass('card-text')
                .html(options.text)
                .appendTo($cardBody);
        }

        // Add buttons
        if (options.buttons && options.buttons.length) {
            const $buttonContainer = $('<div>')
                .addClass('card-buttons')
                .appendTo($cardBody);

            options.buttons.forEach(buttonConfig => {
                const $button = $('<a>')
                    .addClass(`btn btn-sm mx-1 ${buttonConfig.class || 'btn-primary'}`)
                    .html(buttonConfig.text)
                    .attr('href', buttonConfig.href || '#');

                if (buttonConfig.onClick) {
                    $button.on('click', buttonConfig.onClick);
                }

                $buttonContainer.append($button);
            });
        }
        if (options.footer) {
            $('<div>')
                .addClass('card-footer')
                .html(options.footer)
                .appendTo($card)

        }


        return $card;
    }


}

// Example usage:
// const cardGenerator = new BootstrapCardGenerator('card-container');
// cardGenerator.createCard({
//     title: 'Sample Card',
//     image: 'path/to/image.jpg',
//     text: 'This is a sample card description.',
//     buttons: [
//         {
//             text: 'Click me',
//             class: 'btn-primary',
//             onClick: () => alert('Button clicked!')
//         }
//     ]
// });
